import React from "react";
import { Box } from "@mui/material";
import westernFrameUrl from "./WesternCornerDecor.webp";

export default function WesternCornerDecor({
  color = "#5a3418",
  opacity = 0.92,
  bleed = 10,
  zIndex = 6,
  scale = 1.06,
}) {
  return (
    <Box
      aria-hidden="true"
      sx={{
        position: "absolute",
        inset: `-${bleed}px`,
        pointerEvents: "none",
        zIndex,
        transform: `scale(${scale})`,
        transformOrigin: "center",
        filter: "none",
        backdropFilter: "none",
      }}
    >
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "block",
          backgroundColor: color,
          opacity,

          WebkitMaskImage: `url(${westernFrameUrl})`,
          maskImage: `url(${westernFrameUrl})`,

          WebkitMaskRepeat: "no-repeat",
          maskRepeat: "no-repeat",

          WebkitMaskPosition: "center",
          maskPosition: "center",

          WebkitMaskSize: "contain",
          maskSize: "contain",
        }}
      />
    </Box>
  );
}